<div class="main-container">
    <div class="top-menu">
        <div>
            <p-menubar [model]="topMenuItems"></p-menubar>
        </div>
        <div>
            <div class="filter-option-container">
                <p-button label="Filter" (onClick)="filterInvoices()" icon="pi pi-filter"></p-button>
                <p-button label="Clear filters" (onClick)="clearFilters()" icon="pi pi-filter-slash"></p-button>
            </div>
            <div [formGroup]="filterForm" class="filter-form">
                <div class="date-conditions-container">
                    <span>Date: </span>
                    <div class="date-options-container">
                        <div>
                            <span>At: </span>
                            <p-calendar dateFormat="dd/mm/yy" formControlName="dateAt"
                                (onSelect)="filterBySingleDate()"></p-calendar>
                        </div>
                        <div>
                            <span>From</span>
                            <p-calendar dateFormat="dd/mm/yy" formControlName="dateFrom"
                                (onSelect)="filterByDateRange()"></p-calendar>
                            <span>To</span>
                            <p-calendar dateFormat="dd/mm/yy" formControlName="dateTo"
                                (onSelect)="filterByDateRange()"></p-calendar>
                        </div>
                    </div>
                </div>
                <div>
                    <span>Amount: </span>
                    <span>min:</span>
                    <p-inputNumber mode="decimal" minFractionDigits="2" maxFractionDigits="2" locale="fr-FR"
                        formControlName="minAmount"></p-inputNumber>
                    <span>max:</span>
                    <p-inputNumber mode="decimal" minFractionDigits="2" maxFractionDigits="2" locale="fr-FR"
                        formControlName="maxAmount"></p-inputNumber>
                </div>
                <div>
                    <span>Supplier company</span>
                    <p-dropdown [options]="suppliers" formControlName="supplier" optionLabel="name"
                        placeholder="Select" />
                </div>
            </div>
        </div>
    </div>
    <div>
        <p-table [value]="filteredInvoices" [showLoader]="true" styleClass="p-datatable-striped" (sortFunction)="customSort($event)"
        [customSort]="true">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="id">
                        ID <p-sortIcon field="id" />
                    </th>
                    <th pSortableColumn="invoiceNumber">
                        Inv. number <p-sortIcon field="invoiceNumber" />
                    </th>
                    <th pSortableColumn="supplier.name">
                        Supplier<p-sortIcon field="supplier.name" />
                    </th>
                    <th pSortableColumn="date">
                        Date
                        <p-sortIcon field="date" />
                    </th>
                    <th pSortableColumn="amount" width="120">
                        Amount
                        <p-sortIcon field="amount" />
                    </th>
                    <th>
                        Encoded by
                    </th>
                    <th>
                        File
                    </th>
                    <th>
                        Comment
                    </th>
                    <th>
                        Paid
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-invoice>
                <tr>
                    <td>
                        {{invoice.id}}
                    </td>
                    <td>
                        {{invoice.invoiceNumber}}
                    </td>
                    <td>
                        {{invoice.supplier.name}}
                    </td>
                    <td>
                        {{invoice.date | date:'dd/MM/yyyy'}}
                    </td>
                    <td>
                        {{invoice.amount}}
                    </td>
                    <td>
                        {{invoice.createdBy.name}}
                    </td>
                    <td>
                        <div class="file-menu-container">
                            <p-button (onClick)="downloadPdfFile(invoice.id, invoice.fileName)"
                                icon="pi pi-file-pdf"></p-button>
                            <span>
                                {{invoice.fileName}}
                            </span>
                        </div>
                    </td>
                    <td>
                        {{invoice.comment}}
                    </td>
                    <td>
                        <i *ngIf="invoice.isPaid" class="pi pi-check"></i>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>